import React from 'react';
import SwitchLanguage from '../Utilites/SwitchLanguage';

export const LangSelection = ({ onChange, activeLang, auth }) => {

  return (
    <div id="quiz-langSelection" className="text-center">
        <SwitchLanguage onChange={onChange} activeLang={activeLang} auth={auth} /> 
    </div>
  );
};

export default LangSelection;
